(() => {
  const ADDED_LABEL_MS = 1800;

  const setCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
    });
  };

  // Cart page: quantity changes submit right away, so the Update button is only a no-JS fallback
  document.querySelectorAll('[data-wtvr-cart]').forEach((form) => {
    const update = form.querySelector('[data-wtvr-update]');
    if (update) update.hidden = true;
    form.addEventListener('change', (event) => {
      if (event.target.name === 'updates[]') form.submit();
    });
  });

  document.querySelectorAll('[data-wtvr-form]').forEach((form) => {
    const price = form.querySelector('[data-wtvr-price]');
    const button = form.querySelector('[data-wtvr-add]');
    const status = form.querySelector('[data-wtvr-status]');
    const preorderNote = form.querySelector('[data-wtvr-preorder]');
    if (!button) return;

    const labels = {
      add: button.dataset.labelAdd,
      added: button.dataset.labelAdded,
      soldOut: button.dataset.labelSoldOut,
      preorder: button.dataset.labelPreorder,
    };
    let resetTimer;

    const selectedInput = () =>
      form.querySelector('input[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');

    const sync = () => {
      const input = selectedInput();
      if (!input) return;
      const isPreorder = input.dataset.preorder === 'true';
      if (price && input.dataset.price) price.textContent = input.dataset.price;
      button.disabled = input.disabled;
      if (input.disabled) button.textContent = labels.soldOut;
      else button.textContent = isPreorder ? labels.preorder : labels.add;
      if (preorderNote) preorderNote.hidden = !isPreorder;
    };

    form.addEventListener('change', (event) => {
      if (event.target.name !== 'id') return;
      clearTimeout(resetTimer);
      status.textContent = '';
      sync();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const input = selectedInput();
      if (!input || input.disabled || button.getAttribute('aria-busy') === 'true') return;

      clearTimeout(resetTimer);
      status.textContent = '';
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(form.dataset.addUrl, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Could not add to cart.');

        const cart = await fetch(form.dataset.cartUrl, { headers: { Accept: 'application/json' } }).then((r) =>
          r.json()
        );
        setCartCount(cart.item_count);

        const size = input.dataset.size || '';
        button.textContent = labels.added.replace('[size]', size).replace(/:\s*$/, '');
      } catch (error) {
        status.textContent = error.message;
        sync();
        return;
      } finally {
        button.removeAttribute('aria-busy');
      }

      resetTimer = setTimeout(sync, ADDED_LABEL_MS);
    });

    sync();
  });
})();
